module.exports = __webpack_public_path__ + "static/media/homepage-module-1.e516dca5.jpg";